// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.comp-explorer {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-left: 1px;
  background: var(--color-navLeft-background);
  color: var(--color-navLeft-button-active);
  z-index: 100;
}
.comp-explorer .explorer-fullScreenStopper {
  cursor: ew-resize;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
}
.comp-explorer .explorer-mouseBar {
  cursor: ew-resize;
  height: 100%;
  width: 2px;
  border-right: 1px solid var(--color-navLeft-border);
  position: relative;
  float: right;
}
.comp-explorer .explorer-mouseBarActive {
  border-right: 2px solid #6C50A5;
}
.comp-explorer .explorer-mouseBar:hover {
  border-right: 2px solid #6C50A5;
}
.comp-explorer .explorer-mouseBarClose {
  border-right: 1px solid transparent;
}
.comp-explorer .explorer-mouseBarClose:hover {
  border-right: 2px solid #6C50A5;
}
.comp-explorer .explorer-content {
  width: 100%;
  overflow: hidden;
}

@media (max-width: 599px) {
  .comp-explorer {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/explorer/explorer.scss","webpack://./src/theme/responsiv.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;EACA,2CAAA;EACA,yCAAA;EACA,YAAA;AADF;AAGE;EACE,iBAAA;EACA,eAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AADJ;AAIE;EACE,iBAAA;EACA,YAAA;EACA,UAAA;EACA,mDAAA;EACA,kBAAA;EACA,YAAA;AAFJ;AAKE;EACE,+BAAA;AAHJ;AAME;EACE,+BAAA;AAJJ;AAOE;EACE,mCAAA;AALJ;AAQE;EACE,+BAAA;AANJ;AASE;EACE,WAAA;EACA,gBAAA;AAPJ;;ACvCI;EDmDF;IACE,aAAA;EARF;AACF","sourcesContent":["@import '../../theme/responsiv.scss';\n\n.comp-explorer {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  margin-left: 1px;\n  background: var(--color-navLeft-background);\n  color: var(--color-navLeft-button-active);\n  z-index: 100;\n  \n  .explorer-fullScreenStopper {\n    cursor: ew-resize;\n    position: fixed;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 100;\n  }\n\n  .explorer-mouseBar {\n    cursor: ew-resize;\n    height: 100%;\n    width: 2px;\n    border-right: 1px solid var(--color-navLeft-border);\n    position: relative;\n    float: right;\n  }\n\n  .explorer-mouseBarActive {\n    border-right: 2px solid #6C50A5;\n  }\n\n  .explorer-mouseBar:hover {\n    border-right: 2px solid #6C50A5;\n  }\n\n  .explorer-mouseBarClose {\n    border-right: 1px solid transparent;\n  }\n\n  .explorer-mouseBarClose:hover {\n    border-right: 2px solid #6C50A5;\n  }\n\n  .explorer-content {\n    width: 100%;\n    overflow: hidden;\n  }\n}\n\n@include appSize(phone-only) {    \n  .comp-explorer  {\n    display: none;\n  }\n}","@mixin appSize($size) {\n  @if $size == phone-only {\n    @media (max-width: 599px) { @content; }\n  } @else if $size == tablet-portrait-up {\n    @media (min-width: 600px) { @content; }\n  } @else if $size == tablet-landscape-up {\n    @media (min-width: 900px) { @content; }\n  } @else if $size == desktop-up {\n    @media (min-width: 1200px) { @content; }\n  } @else if $size == big-desktop-up {\n    @media (min-width: 1800px) { @content; }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
